import { Grid } from '@mui/material'
import { useHistory } from 'react-router-dom'
import ClientMyAccountActions from '@ClientActions/my-account.action'
import * as Redux from 'redux'
import { connect } from 'react-redux'
import { createRef, useEffect, useState } from 'react'
import { MUserPayment } from '@Models/client/my-account.model'
import ReactToPrint from 'react-to-print'
import moment from 'moment'
import { APIServices } from '@Services/api.service'
import BaseButton from '@Components/Form/BaseButton/BaseButton'
import PageHeader from '@Components/Pages/PageHeader/PageHeader'
import { IPageHeaderActions, ICommonQuery } from '@Models/common.model'
import AccountInfo from '../AccountInfo'

// dummy data
const headerActions: IPageHeaderActions[] = [
    {
        name: 'Statement',
        value: '/my-account/statement',
    },
]

// models section
interface IReceipt {
    // redux
    getPayments?: (params?: ICommonQuery) => void
    payments?: MUserPayment[]
}

const Receipt = (props: IReceipt) => {
    // core section
    const { getPayments, payments } = props
    const history = useHistory()
    const [refElements, setRefElements] = useState<any>([])
    const [disabledIndex, setDisabledIndex] = useState<number | null>(null)

    // hooks section
    /**
     * get data from API when first load
     */
    useEffect(() => {
        if (getPayments) getPayments()
        return () => {
            APIServices.axiosCancelToken()
        }
    }, [])

    /**
     * create Ref when payment changed
     */
    useEffect(() => {
        setRefElements((refE: any) =>
            Array(payments?.length)
                .fill(null)
                .map((_, i) => refE[i] || createRef())
        )
        return () => {
            setRefElements([])
        }
    }, [payments?.length])

    // functions section
    /**
     * handle header action clicked
     * @param action name from header component
     */
    const onHandleActions = (action: string) => {
        history.push(action)
    }

    /**
     * element
     * @returns button print
     */
    const handlePrint = (index: number) => {
        return (
            <BaseButton
                className="variant-red btn-lg-width"
                disabled={index === disabledIndex}
                isLoading={index === disabledIndex}
            >
                Print
            </BaseButton>
        )
    }

    // main section
    return (
        <div>
            <div className="page-account-statement">
                <PageHeader
                    title="My Account"
                    actions={headerActions}
                    getActions={(e: any) => onHandleActions(e)}
                />
                <p className="page-title">Receipt</p>
                <Grid container spacing={3}>
                    {payments?.map((payment: MUserPayment, index: number) => {
                        return (
                            <Grid
                                item
                                md={6}
                                sm={12}
                                key={`${payment?.serial}_invoice_key_${+index}`}
                            >
                                <div
                                    className="page-white-card p-4 receipt-card"
                                    ref={refElements[index]}
                                >
                                    <AccountInfo user={payment?.user} />
                                    <div className="w-100">
                                        <dl className="total-info mt-3">
                                            <dt>Payment Serial:</dt>
                                            <dd>{payment?.serial}</dd>
                                            <br />
                                            <dt>Transaction Method:</dt>
                                            <dd>{payment?.method}</dd>
                                            <br />
                                            <dt>Visa:</dt>
                                            <dd>{payment?.visa}</dd>
                                            <br />
                                            <dt>Transaction Ref:</dt>
                                            <dd>{payment?.transaction}</dd>
                                            <br />
                                            <dt>Invoice:</dt>
                                            <dd>{payment?.code}</dd>
                                            <br />
                                            <dt className="border-0">
                                                Authorization
                                            </dt>
                                            <dd className="border-0">
                                                {payment?.authorization}
                                            </dd>
                                            <br />
                                            <dt className="gray-bg border-0 py-2">
                                                Amount
                                            </dt>
                                            <dd
                                                style={{ marginRight: '-24px' }}
                                                className="gray-bg border-0 py-2"
                                            >
                                                {payment?.amount}
                                            </dd>
                                        </dl>
                                    </div>
                                    <div className="text-right button-print">
                                        <ReactToPrint
                                            documentTitle={`${moment().format(
                                                'DD-MM-YYYY'
                                            )}-${payment?.code}`}
                                            bodyClass="pdf-print-receipt"
                                            trigger={() => handlePrint(index)}
                                            content={() =>
                                                refElements?.[index]?.current
                                            }
                                            onAfterPrint={() => {
                                                setDisabledIndex(null)
                                            }}
                                            onBeforePrint={() => {
                                                setDisabledIndex(index)
                                            }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        )
                    })}
                </Grid>
            </div>
        </div>
    )
}

// store section
const mapStateToProps = (store: any) => {
    const { payments } = store?.client?.myAccount
    return {
        payments,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { getPayments } = ClientMyAccountActions
    return {
        getPayments: (params?: ICommonQuery) =>
            dispatch(getPayments(params) as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Receipt)
